/**
 * Astromeda — PC用の固定フッター（商品ページのみ）
 *
 * 3カラム横並び: [合計金額(税込)] [分割払い + 月々] [出荷予定 + CTA]
 * スマートフォンは assets/astro-sticky-footer.js が別レイアウトで描画する。
 *
 * 設定は snippets/astro-sticky-footer.liquid が window.AstroStickyFooterConfig に流し込む。
 */
(function () {
  "use strict";

  var DEFAULT_CONFIG = {
    default_count: 24,
    installment_counts: [3, 6, 12, 24, 36, 48, 60],
    fees: { "3": 0.125, "6": 0.125, "12": 0.125, "24": 0.125, "36": 0.125, "42": 0.125, "48": 0.125, "54": 0.125, "60": 0.125 },
    show_delivery: true,
    cta_text: "カートに追加する",
    note_text: ""
  };

  function formatJpy(n) { return Math.round(n).toLocaleString("ja-JP"); }
  function calcMonthlyByApr(principal, count, annualRate) {
    if (principal <= 0 || count <= 0) return 0;
    if (!annualRate || annualRate <= 0) return Math.ceil(principal / count);
    var r = annualRate / 12;
    var pow = Math.pow(1 + r, -count);
    return Math.ceil(principal * r / (1 - pow));
  }
  function parsePriceText(s) {
    if (!s) return 0;
    var m = (s + "").replace(/[^0-9]/g, "");
    return m ? parseInt(m, 10) : 0;
  }
  // assets/astro-sticky-footer.js の isMobile() と同一定義。
  // 両モジュールが同じページで読まれるため、判定が食い違うと二重表示になる。
  function isMobile() {
    var ua = navigator.userAgent || "";
    if (/iPad|Tablet|PlayBook|Silk/.test(ua) || (/Android/.test(ua) && !/Mobile/.test(ua))) return false;
    return /Mobi|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) || window.innerWidth < 768;
  }
  function isPc() { return !isMobile(); }


  function buildShadow(config, brandColor) {
    var host = document.createElement("div");
    host.id = "mdl-sticky-footer-pc-host";
    host.style.cssText =
      "all:initial;position:fixed;left:0;right:0;bottom:0;" +
      "z-index:2147483647;pointer-events:none;isolation:isolate;" +
      "transform:translate3d(0,0,0);-webkit-transform:translate3d(0,0,0);" +
      "will-change:transform;backface-visibility:hidden;-webkit-backface-visibility:hidden;";
    document.body.appendChild(host);
    var shadow = host.attachShadow({ mode: "open" });

    shadow.innerHTML =
      "<style>" +
      ":host{all:initial;}" +
      // 外枠: 濃いめのグレー帯。内部の白カードを中央寄せ。
      ".wrap{font-family:-apple-system,'Hiragino Kaku Gothic ProN','Noto Sans JP',sans-serif;color:#111;background:rgba(0,0,0,0.78);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);padding:10px 16px;pointer-events:auto;opacity:0;transition:opacity .15s ease-out;}" +
      ".wrap.show{opacity:1;}" +
      ".inner{max-width:1000px;margin:0 auto;background:#fff;border-radius:0;box-shadow:0 6px 20px rgba(0,0,0,0.20);padding:18px 32px;display:flex;align-items:flex-end;justify-content:space-between;gap:28px;}" +
      ".col{display:flex;flex-direction:column;gap:8px;}" +
      ".lbl{font-size:13px;color:#6b7280;line-height:1.2;}" +
      // 合計 (label 上 / 数字 下、左寄せ)
      ".col-total{min-width:200px;}" +
      ".total-amount{font-size:32px;font-weight:800;color:#111;letter-spacing:-0.02em;line-height:1.15;}" +
      ".total-amount .yen{font-size:20px;font-weight:700;margin-left:2px;}" +
      ".col-total.has-coupon .total-amount{font-size:19px;color:#6b7280;text-decoration:line-through;text-decoration-thickness:1.5px;}" +
      ".col-total.has-coupon .total-amount .yen{font-size:14px;}" +
      ".coupon-amount{font-size:32px;font-weight:800;color:#e13124;letter-spacing:-0.02em;line-height:1.15;}" +
      ".coupon-amount .yen{font-size:20px;font-weight:700;margin-left:2px;}" +
      ".coupon-lbl{font-size:12px;font-weight:700;color:#e13124;letter-spacing:0.02em;}" +
      ".coupon-box[hidden]{display:none;}" +
      // 中央: 出荷予定 (上) + 分割払い (下)
      ".col-center{flex-direction:column;align-items:flex-start;gap:10px;}" +
      ".inst-row{display:flex;align-items:baseline;gap:12px;}" +
      ".col-center .lbl{font-size:14px;color:#374151;font-weight:500;}" +
      ".sel-host{position:relative;align-self:center;}" +
      ".sel-btn{appearance:none;border:1px solid #d1d5db;background:#fff;border-radius:0;padding:9px 32px 9px 14px;font-size:15px;font-weight:600;color:#111;cursor:pointer;position:relative;min-width:110px;text-align:left;font-family:inherit;}" +
      ".sel-btn::after{content:'▾';position:absolute;right:10px;top:50%;transform:translateY(-50%);font-size:12px;color:#6b7280;}" +
      ".sel-pop{position:absolute;bottom:calc(100% + 6px);left:0;background:#fff;border:1px solid #d1d5db;border-radius:0;box-shadow:0 8px 24px rgba(0,0,0,0.18);padding:4px;min-width:124px;max-height:280px;overflow-y:auto;z-index:10;}" +
      ".sel-pop[hidden]{display:none;}" +
      ".sel-pop button{display:block;width:100%;appearance:none;border:0;background:#fff;font-size:15px;font-weight:600;color:#111;padding:9px 14px;text-align:left;cursor:pointer;border-radius:0;font-family:inherit;}" +
      ".sel-pop button:hover{background:#f3f4f6;}" +
      ".sel-pop button.is-active{background:" + brandColor + ";color:#fff;}" +
      ".monthly-val{font-size:32px;font-weight:800;color:" + brandColor + ";letter-spacing:-0.01em;line-height:1.15;text-decoration:underline;text-decoration-color:#fde68a;text-decoration-thickness:10px;text-underline-offset:-5px;text-decoration-skip-ink:none;}" +
      ".monthly-val .yen{font-size:20px;font-weight:700;margin-left:2px;}" +
      // 右 (CTA のみ)
      ".col-right{align-items:stretch;min-width:260px;}" +
      // 出荷予定 (中央列の上に移動)
      ".delivery-row{display:flex;align-items:center;justify-content:flex-start;gap:8px;font-size:16px;color:#111;font-weight:700;letter-spacing:-0.01em;}" +
      ".delivery-row svg{width:22px;height:22px;flex-shrink:0;color:" + brandColor + ";stroke-width:2.2;}" +
      ".cta{appearance:none;border:0;background:" + brandColor + ";color:#fff;font-weight:800;font-size:17px;padding:15px 32px;border-radius:0;cursor:pointer;text-decoration:none;letter-spacing:0.02em;white-space:nowrap;font-family:inherit;display:flex;align-items:center;justify-content:center;gap:10px;}" +
      ".cta:hover{background:#c52a1f;}" +
      ".cta:active{transform:scale(0.99);}" +
      ".cta[disabled]{background:#9ca3af;cursor:not-allowed;}" +
      ".cta svg{width:20px;height:20px;}" +
      "</style>" +
      "<div class='wrap' id='wrap'>" +
        "<div class='inner'>" +
          "<div class='col col-total'>" +
            "<div class='lbl'>合計金額（税込）</div>" +
            "<div class='total-amount'><span id='total'>—</span><span class='yen'>円</span></div>" +
            "<div class='coupon-box' id='coupon-box' hidden>" +
              "<div class='coupon-lbl' id='coupon-lbl'></div>" +
              "<div class='coupon-amount'><span id='coupon-total'>—</span><span class='yen'>円</span></div>" +
            "</div>" +
          "</div>" +
          "<div class='col col-center'>" +
            (config.show_delivery ? (
              "<div class='delivery-row'>" +
                "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M3 7h11v10H3z'/><path d='M14 10h4l3 3v4h-7'/><circle cx='7' cy='17' r='2'/><circle cx='17' cy='17' r='2'/></svg>" +
                "<span id='delivery'>—</span>" +
              "</div>"
            ) : "") +
            "<div class='inst-row'>" +
              "<span class='lbl'>分割払い</span>" +
              "<div class='sel-host'>" +
                "<button type='button' class='sel-btn' id='count-btn'>—回</button>" +
                "<div class='sel-pop' id='count-pop' hidden></div>" +
              "</div>" +
              "<span class='lbl' style='margin-left:8px;'>月々</span>" +
              "<span class='monthly-val'><span id='monthly'>—</span><span class='yen'>円</span></span>" +
            "</div>" +
          "</div>" +
          "<div class='col col-right'>" +
            "<button type='button' class='cta' id='cta'>" +
              "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><circle cx='9' cy='21' r='1'/><circle cx='20' cy='21' r='1'/><path d='M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6'/></svg>" +
              "<span>" + (config.cta_text || "カートに追加する") + "</span>" +
            "</button>" +
          "</div>" +
        "</div>" +
      "</div>";
    return { host: host, shadow: shadow };
  }

  function readDeliveryText() {
    var el = document.querySelector(".mdl-delivery-est--pdp");
    if (!el) return null;
    var txt = (el.textContent || "").trim().replace(/\s+/g, " ");
    return txt || null;
  }
  // shop config の price_selector を優先、無ければ Globo の data 属性、それも無ければ Dawn 系の標準クラス
  function findGloboPriceEl(shopConfig) {
    var candidates = [];
    // shop config の price_selector はカンマ区切り対応 (テストテーマ + ライブテーマ両対応)
    if (shopConfig && shopConfig.price_selector) {
      String(shopConfig.price_selector).split(',').forEach(function (s) {
        var trimmed = s.trim();
        if (trimmed) candidates.push(trimmed);
      });
    }
    candidates.push("[data-gpo-product-unit-price]");
    candidates.push("[data-pdp-total]");
    candidates.push(".price-item--regular");
    candidates.push(".price-item--sale");
    for (var i = 0; i < candidates.length; i++) {
      try { var el = document.querySelector(candidates[i]); if (el) return el; } catch (e) {}
    }
    return null;
  }
  function findRealAddToCartButton() {
    var globoClone = document.querySelector(".gpo-clone-atc-button:not([disabled])");
    if (globoClone) return globoClone;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var btn = form.querySelector('button[type="submit"][name="add"]:not([disabled]), button[type="submit"]:not([disabled])');
      if (btn) return btn;
    }
    return document.querySelector('[name="add"]:not([disabled])');
  }

  function init(ctx) {
    var shopConfig = ctx.shopConfig || {};
    var BRAND_COLOR = shopConfig.brand_color || "#e13124";
    var CTA_RADIUS = (shopConfig.cta_radius != null) ? shopConfig.cta_radius : 0;
    var rawConfig = ctx.config || {};
    var config = {};
    Object.keys(DEFAULT_CONFIG).forEach(function (k) { config[k] = DEFAULT_CONFIG[k]; });
    Object.keys(rawConfig).forEach(function (k) { config[k] = rawConfig[k]; });

    if (!isPc()) return;
    if (location.pathname.indexOf("/products/") === -1) return;
    if (document.getElementById("mdl-sticky-footer-pc-host")) return;

    var built = buildShadow(config, BRAND_COLOR);
    var shadow = built.shadow;
    var wrap = shadow.getElementById("wrap");
    var totalEl = shadow.getElementById("total");
    var monthlyEl = shadow.getElementById("monthly");
    var deliveryEl = shadow.getElementById("delivery");
    var countBtn = shadow.getElementById("count-btn");
    var countPop = shadow.getElementById("count-pop");
    var ctaEl = shadow.getElementById("cta");


    var counts = (config.installment_counts || DEFAULT_CONFIG.installment_counts)
      .map(function (c) { return parseInt(c, 10); })
      .filter(function (c) { return isFinite(c) && c > 0; });
    if (!counts.length) counts = DEFAULT_CONFIG.installment_counts.slice();
    var currentCount = parseInt(config.default_count, 10);
    if (counts.indexOf(currentCount) === -1) currentCount = counts[0];
    function rebuildCountPop() {
      countPop.innerHTML = counts.map(function (n) {
        return "<button type='button' data-n='" + n + "'" + (n === currentCount ? " class='is-active'" : "") + ">" + n + "回</button>";
      }).join("");
      countPop.querySelectorAll("button").forEach(function (b) {
        b.onclick = function (e) {
          e.stopPropagation();
          currentCount = parseInt(b.dataset.n, 10);
          countBtn.textContent = currentCount + "回";
          countPop.hidden = true;
          rebuildCountPop();
          updateMonthly();
        };
      });
    }
    countBtn.textContent = currentCount + "回";
    rebuildCountPop();
    countBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      countPop.hidden = !countPop.hidden;
    });
    document.addEventListener("click", function () { countPop.hidden = true; });
    countPop.addEventListener("click", function (e) { e.stopPropagation(); });

    var currentTotal = 0;
    var couponOff = parseInt(config.coupon_discount, 10) || 0;
    var couponBox = shadow.getElementById("coupon-box");
    var couponTotalEl = shadow.getElementById("coupon-total");
    var couponLblEl = shadow.getElementById("coupon-lbl");
    var totalCol = shadow.querySelector(".col-total");
    if (couponOff > 0 && couponLblEl) couponLblEl.textContent = config.coupon_label || "";

    function setTotal(amount) {
      currentTotal = amount || 0;
      totalEl.textContent = currentTotal > 0 ? formatJpy(currentTotal) : "—";
      var showCoupon = couponOff > 0 && currentTotal > couponOff;
      if (couponBox) couponBox.hidden = !showCoupon;
      if (totalCol) totalCol.classList.toggle("has-coupon", showCoupon);
      if (showCoupon && couponTotalEl) couponTotalEl.textContent = formatJpy(currentTotal - couponOff);
      updateMonthly();
    }
    function updateMonthly() {
      if (currentTotal <= 0) {
        monthlyEl.textContent = "—";
        return;
      }
      var fees = config.fees || DEFAULT_CONFIG.fees;
      var rate = fees[String(currentCount)];
      if (rate == null) {
        var defined = Object.keys(fees);
        rate = defined.length ? fees[defined[0]] : 0;
      }
      var m = calcMonthlyByApr(currentTotal, currentCount, rate);
      monthlyEl.textContent = formatJpy(m);
    }
    function refreshDelivery() {
      if (!deliveryEl) return;
      // SP sticky-footer / pdp-delivery-flow と同じ「営業日数」 ロジックに統一:
      //   1. data-mdl-delivery-business-days 属性 (= 商品メタ経由、 商品ごとに変えられる)
      //   2. 旧 .mdl-delivery-est--pdp テキストから数字抽出 (互換性)
      //   3. config.default_business_days
      //   4. デフォルト 10
      var days = 0;
      try {
        var attrEl = document.querySelector('[data-mdl-delivery-business-days]');
        if (attrEl) {
          var raw = attrEl.getAttribute('data-mdl-delivery-business-days') || attrEl.textContent || '';
          var n = parseInt(raw, 10);
          if (isFinite(n) && n > 0) days = n;
        }
      } catch (e) {}
      if (!days) {
        try {
          var legacyEl = document.querySelector(".mdl-delivery-est--pdp");
          if (legacyEl) {
            var ltxt = (legacyEl.textContent || "").trim();
            var lm = ltxt.match(/(\d+)/);
            if (lm) {
              var ln = parseInt(lm[1], 10);
              if (isFinite(ln) && ln > 0) days = ln;
            }
          }
        } catch (e) {}
      }
      if (!days) {
        var dflt = parseInt(config && config.default_business_days, 10);
        if (isFinite(dflt) && dflt > 0) days = dflt;
      }
      if (!days) days = 10;
      deliveryEl.textContent = "最短 " + days + "営業日でお届け";
    }
    function refreshPrice() {
      var el = findGloboPriceEl(shopConfig);
      if (!el) return false;
      var p = parsePriceText(el.textContent);
      if (p > 0) setTotal(p);
      return true;
    }

    function showCtaError(message) {
      var span = ctaEl.querySelector("span");
      if (span) span.textContent = message;
      setTimeout(function () {
        if (span) span.textContent = config.cta_text || "カートに追加する";
      }, 4000);
    }
    // 「処理中」と「購入可否」は別に保持し、disabled は必ずここで算出する。
    // 直接代入すると一方の解除が他方を踏み潰す。
    var ctaBusy = false;
    var ctaAvailable = true;
    function applyCtaDisabled() { ctaEl.disabled = ctaBusy || !ctaAvailable; }
    function syncCtaAvailability() {
      var realBtn = document.querySelector('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]');
      ctaAvailable = !(realBtn && realBtn.disabled);
      applyCtaDisabled();
    }
    syncCtaAvailability();
    setInterval(syncCtaAvailability, 1000);

    ctaEl.addEventListener("click", function () {
      syncCtaAvailability();
      if (ctaBusy || !ctaAvailable) return;
      var btn = findRealAddToCartButton();
      if (btn) {
        try { btn.click(); } catch (e) {}
        ctaBusy = true;
        applyCtaDisabled();
        var span = ctaEl.querySelector("span");
        if (span) span.textContent = "追加中…";
        setTimeout(function () {
          ctaBusy = false;
          applyCtaDisabled();
          if (span) span.textContent = config.cta_text || "カートに追加する";
        }, 2000);
      } else {
        var form = document.querySelector('form[action*="/cart/add"]');
        if (!form) return;
        var fd = new FormData(form);
        fd.set("quantity", "1");
        fetch("/cart/add.js", { method: "POST", credentials: "same-origin", headers: { Accept: "application/json" }, body: fd })
          .then(function (r) {
            if (!r.ok) return r.json().catch(function () { return null; }).then(function (data) {
              showCtaError((data && (data.description || data.message)) || "カートに追加できませんでした");
            });
            location.href = "/cart";
          })
          .catch(function () { showCtaError("カートに追加できませんでした"); });
      }
    });

    refreshPrice();
    refreshDelivery();

    setTimeout(function () { wrap.classList.add("show"); }, 100);

    // バリエーション変更時にテーマが価格コンテナごと差し替えるため、
    // 監視対象の入れ替わりを検知して張り直す。
    var priceObserver = null;
    var observedPriceEl = null;
    function resolvePriceEl() {
      var globoEl = findGloboPriceEl(shopConfig);
      if (globoEl && globoEl !== observedPriceEl) {
        if (priceObserver) priceObserver.disconnect();
        observedPriceEl = globoEl;
        priceObserver = new MutationObserver(function () { refreshPrice(); });
        priceObserver.observe(globoEl, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ["data-amount"] });
        refreshPrice();
      } else if (!globoEl && observedPriceEl && !document.contains(observedPriceEl)) {
        if (priceObserver) priceObserver.disconnect();
        priceObserver = null;
        observedPriceEl = null;
      }
    }
    // 次回の予約はこのループだけが行う。再評価の呼び出しでループを増やさない。
    function priceWatchLoop() {
      resolvePriceEl();
      setTimeout(priceWatchLoop, 500);
    }
    priceWatchLoop();
    document.addEventListener("change", function (e) {
      if (e.target && e.target.name === "id") setTimeout(resolvePriceEl, 80);
    }, true);

    // data-mdl-delivery-business-days 属性が後から DOM に挿入される theme もあるため、
    // body の subtree を一定期間監視して値が更新されたら再描画 (= SP sticky-footer と同等)
    try {
      var mo2 = new MutationObserver(refreshDelivery);
      mo2.observe(document.body, {
        childList: true, subtree: true,
        attributes: true, attributeFilter: ['data-mdl-delivery-business-days']
      });
      setTimeout(function () { try { mo2.disconnect(); } catch (e) {} }, 10000);
    } catch (e) {}
    // 旧 .mdl-delivery-est--pdp テキスト変化にも対応 (= 後方互換)
    var legacyDomEl = document.querySelector(".mdl-delivery-est--pdp");
    if (legacyDomEl) {
      try {
        var mo3 = new MutationObserver(refreshDelivery);
        mo3.observe(legacyDomEl, { childList: true, characterData: true, subtree: true });
      } catch (e) {}
    }
  }

  // =====================================================================
  // 快適度ゲージ (sticky-footer-pc 内オプション機能)
  // =====================================================================

  function boot() {
    var cfg = window.AstroStickyFooterConfig;
    if (!cfg || !cfg.enabled) return;
    init({ config: cfg.config || {}, shopConfig: cfg.shop || {} });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
